export const siteTitle = 'SparkLing'
export const contactEmail = 'SprkLng@uw.edu'
export const feedbackEmail = 'feedback@sparklinglanguage.com'

export const unitTestPassPercentage = 80 // 80% is passing

export const physicalAddress =
  'Portage Bay Building, Box 357988, University of Washington, Seattle, WA 98195-7988'

export type SocialLinkData = {
  name: string
  href: string
  imgPath: string
}
export const socialIconSize = 40
export const socialLinks: SocialLinkData[] = [
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/uwilabs/',
    imgPath: '/img/linked-in.png',
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/ILABS.UW/',
    imgPath: '/img/facebook.png',
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/uw_ilabs/',
    imgPath: '/img/instagram.png',
  },
]
